import { IUserProfileModel } from '../models';

import { PERMISSION_TYPE, ROLE_PERMISSION_MAP } from '../constants/permissions_constants';
import { USER_PROFILE_ROLES } from '../constants/user_profile_constants';

/**
 * Fetches a list of permissions for a given role
 * @param role - The role to get permissions for
 * @returns Array of permission strings
 */
export function getPermissionsForRole(role?: USER_PROFILE_ROLES): PERMISSION_TYPE[] {
  if (!role) {
    return [];
  }

  return ROLE_PERMISSION_MAP[role] || [];
}

/**
 * Checks if a role has a specific permission
 * @param role - The role to check
 * @param permission - The permission to check for
 * @returns True if the role has the permission
 */
export function roleHasPermission(role: USER_PROFILE_ROLES | undefined, permission: PERMISSION_TYPE): boolean {
  const permissions = getPermissionsForRole(role);
  return permissions.includes(permission);
}

/**
 * Checks if a user profile has a specific permission based on their role
 * @param userProfile - User profile object with role property
 * @param permission - The permission to check for
 * @returns True if the user profile has the permission
 */
export function userProfileHasPermission(userProfile: IUserProfileModel | undefined, permission: PERMISSION_TYPE): boolean {
  return roleHasPermission(userProfile?.role, permission);
}
